// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__25DTg","overflowing":"ReadFullNote_overflowing__1T0CC"};